
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Componente 32 – 1","xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 604"}},[_c('g',{attrs:{"data-name":"Componente 31 – 1"}},[_c('path',{attrs:{"data-name":"União 3","d":"M12.876 40h-1.72A5.162 5.162 0 016 34.844V5.625A5.631 5.631 0 0111.624 0h21.873a1.249 1.249 0 011.25 1.25 1.249 1.249 0 01-1.25 1.249H11.624a3.129 3.129 0 00-3.126 3.125 3.129 3.129 0 003.126 3.125h21.873a1.249 1.249 0 011.25 1.25v28.75a1.249 1.249 0 01-1.25 1.25zm19.373-2.5V11.25H14.124V37.5zM8.5 34.844a2.658 2.658 0 002.656 2.656h.47V11.25A5.592 5.592 0 018.5 10.3zm3.126-27.969a1.25 1.25 0 01-1.251-1.25 1.251 1.251 0 011.251-1.25h21.873a1.25 1.25 0 011.25 1.25 1.249 1.249 0 01-1.25 1.25z","fill":"#023e71"}})]),_c('path',{attrs:{"data-name":"Retângulo 831","fill":"none","d":"M0 0h40v40H0z"}})])])
          )
        }
      }
    